// extracted by mini-css-extract-plugin
export default {"wrapper":"X51Lr","button":"QvtTi"};